/**
 * Creates a cookie. Defaults to creating a session cookie unless `exp` is set.
 *
 * @param {string} key The key to store the cookie under
 * @param {string} value The value to store in the cookie
 * @param {Number} exp The expiry of the cookie in days
 *
 * @public
 * @author Alex Kasemir
 */
const createCookie = (key, value, exp = null) => {
  let expiresStr = ``;
  if (exp !== null) {
    const date = new Date();
    date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    expiresStr = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${key}=${value}${expiresStr}; path=/`;
};

/** @component */
export default createCookie;
